import { render, staticRenderFns } from "./OtherJournal.vue?vue&type=template&id=4d42583e&"
import script from "./OtherJournal.vue?vue&type=script&lang=js&"
export * from "./OtherJournal.vue?vue&type=script&lang=js&"
import style0 from "./OtherJournal.vue?vue&type=style&index=0&id=4d42583e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports